import { render, staticRenderFns } from "./ImportHistoryItem.vue?vue&type=template&id=05bebb8b&scoped=true&"
import script from "./ImportHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./ImportHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImportHistoryItem.vue?vue&type=style&index=0&id=05bebb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bebb8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
